import styled from 'styled-components';
import { Form } from 'antd';
import { breakpoints } from 'config/config';

export const StyledProfileForm = styled(Form)`
  display: flex;
  margin-bottom: 48px;
  flex-direction: column;
  justify-content: space-around;
  background-color: ${(props) => props.theme.white};
  width: 60%;
  font-size: 16px;
  font-weight: 400;

  .margin-top {
    padding-top: 15px;
  }

  .ant-form-item {
    margin-bottom: 5px;
  }

  .inputs {
    display: flex;
    flex-direction: column;
    padding: 0px;
    gap: 16px;

    .collumn {
      display: flex;
      gap: 20px;

      .half-collumn {
        flex: 1;
      }
    }

    .change-password-title {
      margin-top: 32px;
      margin-bottom: 0;
    }
  }

  .cstm-btn {
    width: 348px;
    height: 52px;
    border-radius: 45px;
    margin-left: auto;
    margin-top: 32px;
    background: ${({ theme }) => theme.colorPrimary};
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .basic-info {
      .collumn {
        .half-collumn {
          font-size: 0.875rem !important;
        }
      }
    }

    .change-password {
      .profile-change-appword-input {
        font-size: 0.875rem;

        .ant-input{
          font-size: 1rem;
        }
      }
    }
  }

  @media (max-width: 800px) {
    margin-right: 0px;
    width: 100%;

    .inputs {
      .collumn {
        flex-direction: column;
        gap: 0;
      }
    }
  }
`;
